import { render, staticRenderFns } from "./FormContentCategoryComponent.vue?vue&type=template&id=2af8c1d4&scoped=true"
import script from "./FormContentCategoryComponent.vue?vue&type=script&lang=js"
export * from "./FormContentCategoryComponent.vue?vue&type=script&lang=js"
import style0 from "./FormContentCategoryComponent.vue?vue&type=style&index=0&id=2af8c1d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af8c1d4",
  null
  
)

export default component.exports